import React from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { service_list } from "../utils"

export default function CertificateRoot() {
    const location = useLocation()
    const navigate = useNavigate()

    const isRoot = location.pathname === "/certificates"

    const certificateService = service_list.find(
        (item) => item.title === "Certificate Management"
    )

    return (
        <div style={styles.container}>
            {/* Header */}
            <header style={styles.header}>
                <h2 style={styles.title}>Certificate Management</h2>
                <p style={styles.subtitle}>
                    Fill all mandatory * fields data for generate student certificates
                </p>
            </header>

            {/* Body */}
            <div style={styles.body}>
                <main style={styles.content}>
                    {isRoot ? (
                        <div style={styles.grid}>
                            {certificateService?.list?.map((cert, index) => (
                                <div
                                    key={index}
                                    style={styles.card}
                                    onClick={() =>
                                        navigate(
                                            `/certificates/${cert.to
                                                .toLowerCase()
                                                .replace(/[^a-z0-9]+/g, "-")}`
                                        )
                                    }
                                >
                                    <div style={styles.icon}>{cert.icon}</div>
                                    <span style={styles.label}>{cert.name}</span>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <Outlet />
                    )}
                </main>
            </div>
        </div>
    )
}
const styles = {
    container: {
        minHeight: "100vh",
        background: "#f7f9fc",
        padding: "16px"
    },
    header: {
        marginBottom: "20px"
    },
    title: {
        margin: 0,
        fontSize: "24px",
        fontWeight: 600,
        textAlign: "center"
    },
    subtitle: {
        margin: "4px 0 0",
        color: "#666",
        textAlign: "center"
    },
    body: {
        display: "flex",
        justifyContent: "center"
    },
    content: {
        width: "100%",
        maxWidth: "1100px",
        background: "#fff",
        borderRadius: "10px",
        padding: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
    },
    grid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
        gap: "16px"
    },
    card: {
        display: "flex",
        alignItems: "center",
        gap: "12px",
        padding: "14px 16px",
        borderRadius: "8px",
        border: "1px solid #eee",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: "#fafafa",
        flexDirection:"column"
    },
    icon: {
        fontSize: "28px",
        color: "#1976d2"
    },
    label: {
        fontWeight: 500,
        fontSize: "14px"
    }
}
